(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name itecAdministracio.api.persona.factory:PersonaFactory
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio.api.llicencia')
    .factory('LlicenciaFactory', LlicenciaFactory);

  function LlicenciaFactory(AdmConstant, DataFactory) {
    var api = AdmConstant.SERVER_PATH_ADMINISTRACIO + 'entitats';
    
    var LlicenciaBase = {

      get: function(idEntitat, id, form){
        var url = api + '/' + idEntitat + '/llicencies/' + id;
        return DataFactory.getWithParams(url, form);
      },
        
      add: function(idEntitat, obj){
        var url = api + '/' + idEntitat + '/llicencies';
        return DataFactory.add(url,obj);
      },

      update: function(idEntitat, id, obj){
        var url = api + '/' + idEntitat + '/llicencies/' + id;
        return DataFactory.update(url,obj);
      },

      delete: function(idEntitat, id){
        var url = api + '/' + idEntitat + '/llicencies';
        return DataFactory.delete(url, id);
      }
      
    };
    return LlicenciaBase;
  }
}());
